import React from 'react'
import { Section } from '@shared/components/section'

import { advantageData } from './data'

import styles from './style.module.scss'

export const View = () => (
	<Section className={styles.wrapper}>
		<h2>Преимущества работы с нами</h2>
		<div className={styles.items}>
			{advantageData.map(({ Icon, title, content }) => (
				<div key={title} className={styles.item}>
					<div className={styles.itemTitle}>
						<Icon className={styles.itemIcon} />
						<h5>{title}</h5>
					</div>
					<div className={styles.itemContent}>{content}</div>
				</div>
			))}
		</div>
	</Section>
)
